/*
 * File: ClinicalPages.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 10/21/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays a clinical widget page
 */
import React from "react";
import WidgetIndexPage from "./WidgetIndexPage";
import ClinicalPageSubheader from "./ClinicalPageSubheader";
import PatientIdStorage from "../store/PatientIdStore";
import UINotFound from "components/ui/UINotFound";
import { StoreContext } from "utils/useStore";
import { RouteComponentProps } from "react-router";
import { ContextType } from "react";
import { observer } from "mobx-react";

type Props = RouteComponentProps<{ widget: string }>;

class ClinicalPages extends React.Component<Props> {
  static contextType = StoreContext;
  context!: ContextType<typeof StoreContext>;

  widgetComponent: null;

  constructor(props: Props) {
    super(props);
    this.widgetComponent = null;
  }
  render() {
    if (this.context === undefined) {
      throw new Error("ClinicalPages is missing context");
    }

    const clinicalPref = this.context.getPreference("clinicalSummary");
    const { match } = this.props;
    const patientId = PatientIdStorage.getId();
    if (!patientId) return <UINotFound message="No Patient was selected" />;

    const widgetName = match.params.widget;
    const widget = clinicalPref.preferences.find(
      widget => widget.key === widgetName
    );
    return (
      <React.Fragment>
        {!widget && <UINotFound message={"Not a valid clinical route"} />}
        {widget && (
          <React.Fragment>
            <ClinicalPageSubheader title={widget.title} color={widget.color} />
            {this.widgetComponent ? (
              this.widgetComponent
            ) : (
              <WidgetIndexPage widget={widgetName} />
            )}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default observer(ClinicalPages);
